import { ITabulatorInstance } from "./types";

export const tabulatorInstance: ITabulatorInstance = {
	defaults: {
		ajaxConfig: {
			method: "GET", //set request type to Position
			mode: "cors",
			headers: {
				Accept: "application/json",
				"X-Requested-With": "XMLHttpRequest",
				"Content-type": "application/json; charset=utf-8",
			},
		},
		placeholder: "Data not available",
		loadingMessage: "Loading data...",
		errorMessage: "Loading failed.",
		dataSendParams: {
			page: "page",
			size: "page_size",
		},
		dataReceiveParams: {
			last_page: "total_pages",
			current_page: "page",
			per_page: "page_size",
		},
	},
};
